module.exports = __webpack_public_path__ + "static/media/p3_0.b31d92b9.png";